import DashboardCreator from "../components/DashboardCreator";
import DashboardJudge from "../components/DashboardJudge";
import { useAuth } from "../context/AuthContext";

export default function Dashboard() {
  const { profile } = useAuth();

  if (!profile) {
    return (
      <div className="flex items-center justify-center h-screen text-gray-400">
        Loading dashboard...
      </div>
    );
  }

  // Match roles from backend
  if (profile.role === "user") return <DashboardJudge />;
  if (profile.role === "contributor") return <DashboardCreator />;

  return (
    <div className="flex items-center justify-center h-screen text-red-400">
      Unknown role: {profile.role}
    </div>
  );
}
